// extracted by mini-css-extract-plugin
module.exports = {"select":"_25qh3WalDmF1okyfoRz2wa"};